var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1420 4669 c-209 -54 -391 -199 -484 -383 -47 -94 -883 -2330 -907 -2426 -20 -82 -23 -119 -23 -265 1 -150 4 -181 26 -266 50 -187 118 -325 226 -461 338 -425 936 -560 1427 -323 148 71 297 190 396 315 170 214 250 433 265 723 l7 127 207 0 207 0 7 -127 c15 -297 100 -524 277 -737 209 -252 510 -400 840 -413 269 -11 490 49 703 191 425 284 621 809 481 1291 -31 107 -856 2301 -892 2372 -124 245 -384 403 -663 403 -373 0 -688 -274 -739 -644 -7 -47 -11 -271 -11 -567 l0 -489 -209 0 -210 0 -3 538 c-4 522 -5 539 -27 612 -46 153 -135 291 -245 381 -77 63 -219 132 -313 153 -99 22 -249 20 -343 -5z m-53 -2350 c254 -64 469 -286 534 -549 18 -71 18 -269 0 -339 -68 -269 -277 -483 -538 -552 -111 -30 -270 -30 -378 0 -216 59 -385 198 -480 396 -61 126 -79 218 -72 364 12 270 156 495 397 620 172 89 347 109 537 60z m2777 -1 c142 -39 287 -133 382 -248 58 -71 128 -215 148 -307 9 -40 16 -113 16 -163 0 -120 -22 -215 -75 -325 -97 -199 -262 -335 -480 -396 -101 -28 -257 -30 -360 -5 -278 67 -501 298 -559 578 -86 417 200 821 629 887 80 13 212 3 299 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.5fa37bf6ad97b18048ba988b7e9439ea.svg";
export { ForwardRef as ReactComponent };